import Mandala from "./Mandala";
import { MaskLine, FadeIn } from "./motion";

export default function PageHeader({ eyebrow, title, accent, description }) {
  return (
    <section className="relative overflow-hidden bg-navy text-white grain" data-testid="page-header">
      <Mandala className="absolute -right-32 -bottom-40 w-[480px] h-[480px] text-steel opacity-50 spin-slow" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(37,99,235,0.16),transparent_55%)]" />
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-16 lg:pt-40 lg:pb-24">
        <FadeIn>
          <p className="font-mono text-[11px] tracking-[0.3em] text-saffron mb-5">{eyebrow}</p>
        </FadeIn>
        <h1 aria-label={`${title} ${accent || ""}`.trim()} className="font-display font-extrabold tracking-tight leading-[1.04] text-4xl sm:text-5xl lg:text-6xl max-w-3xl">
          <MaskLine delay={0.1}>{title}</MaskLine>
          {accent && (
            <MaskLine delay={0.25}>
              <span className="text-saffron">{accent}</span>
            </MaskLine>
          )}
        </h1>
        {description && (
          <FadeIn delay={0.45}>
            <p className="mt-6 max-w-xl text-slate-300 text-base sm:text-lg leading-relaxed">{description}</p>
          </FadeIn>
        )}
      </div>
    </section>
  );
}
